import PreviewCampaign from './components/PreviewCampaign';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter';
import { connect } from 'react-redux';
import {
  getPreviewCampaign
} from '../../shared/redux/entities/actions';

import './assets/bootstrapOverrides.css'
import './assets/PreviewCampaign.css'

function mapStateToProps(state, props){
  return {
    previewToken:props.match.params.previewToken
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({getPreviewCampaign},dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(PreviewCampaign));



// WEBPACK FOOTER //
// ./src/routes/PreviewCampaign/index.js